
(function() {
  var result = { translations: { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": " {{amountNumberValue}}\xA0{{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.1326"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1326",
    "ar-eg": "static-7.1326",
    "bg": "static-7.1326",
    "bn": "static-7.1326",
    "ca-es": "static-7.1326",
    "cs": "static-7.1326",
    "da": "static-7.1326",
    "de": "static-7.1326",
    "el": "static-7.1326",
    "en-gb": "static-7.1326",
    "en": "static-7.1326",
    "es-mx": "static-7.1326",
    "es": "static-7.1326",
    "et": "static-7.1326",
    "fi": "static-7.1326",
    "fr-ca": "static-7.1326",
    "fr": "static-7.1326",
    "he-il": "static-7.1326",
    "hi": "static-7.1326",
    "hr": "static-7.1326",
    "hu": "static-7.1326",
    "id": "static-7.1326",
    "it": "static-7.1326",
    "ja": "static-7.1326",
    "ko": "static-7.1326",
    "lt": "static-7.1326",
    "ms": "static-7.1326",
    "nl": "static-7.1326",
    "no": "static-7.1326",
    "pl": "static-7.1326",
    "pt-br": "static-7.1326",
    "pt-pt": "static-7.1326",
    "ro": "static-7.1326",
    "ru": "static-7.1326",
    "sk": "static-7.1326",
    "sl": "static-7.1326",
    "sv": "static-7.1326",
    "th": "static-7.1326",
    "tl": "static-7.1326",
    "tr": "static-7.1326",
    "uk": "static-7.1326",
    "vi": "static-7.1326",
    "x-pseudo": "static-7.1326",
    "zh-cn": "static-7.1326",
    "zh-hk": "static-7.1326",
    "zh-tw": "static-7.1326"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.1326'}); }
})();


